/* eslint-disable max-len */
import { mapMutations } from 'vuex';

export default {
  data() {
    return {
      errors: [],
      rules: {
        email: [
          (v) => !!v || this.$t('common.validation.required'),
          (v) => /^[A-z0-9\-.]{3}.*@[A-z0-9]*\.[A-z]{2}.*$/gi.test(v) || this.$t('common.validation.email'),
        ],
        password: [
          (v) => !!v || this.$t('common.validation.required'),
          (v) => v.length > 7 || this.$t('common.validation.passwordMinLength'),
        ],
        passwordRules: [
          (v) => !!v || this.$t('common.validation.required'),
          (value) => (value && value.length > 8) || this.$t('common.validation.min', { num: 8 }),
          // (value) => (value && /\d/.test(value)) || this.$t('common.validation.oneDigit'),
          // (value) => (value && /[A-Z]{1}/.test(value)) || this.$t('common.validation.oneCapitalLetter'),
          // (value) => (value && /[a-z]{1}/.test(value)) || this.$t('common.validation.oneLetter'),
          // (value) => (value && /[^A-Za-z0-9]/.test(value)) || this.$t('common.validation.oneSpecialCharacter'),
        ],
        repeat: [
          (v) => !!v || this.$t('common.validation.required'),
          (v) => v === this.$t('common.validation.passwordRepeat'),
        ],
        required: [
          (v) => !!v || this.$t('common.validation.required'),
        ],
        phoneNumber: [
          (v) => !!v || this.$t('common.validation.required'),
          (v) => v.length === 10 || this.$t('common.validation.phoneNumber'),
        ],
      },
    };
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler() {
        this.errors = [];
      },
    },
  },
  methods: {
    ...mapMutations('app', ['SET_error', 'SET_loading', 'SET_token', 'SET_username']),
  },
};
